/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	if (typeof execScript !== "undefined")
		execScript(src);
	else
		eval.call(null, src);
}



//////////////////
// WEBPACK FOOTER
// /Users/mac/PlayGround/~/script-loader/addScript.js
// module id = ../../../../script-loader/addScript.js
// module chunks = 3